import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import { Tracking } from '@nerdwallet/nw-client-lib';
var eventName = 'PRODUCT_INTERACTION_EVENT';
var endpoint = 'productinteraction'; // TODO: duplicated from credit-cards-client, maybe refactor to not use window calls

function logInteraction(type, card) {
  var productLocation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  if (typeof window === 'undefined') return;
  var clickHeader = {
    productId: card.id.toString(),
    category: 'Credit Card',
    productSlug: card.slug
  };
  if (productLocation) clickHeader.productLocation = productLocation;
  window.nwa.track(eventName, {
    clickHeader: clickHeader,
    type: type,
    elementName: 'manual-card',
    endpoint: endpoint
  });
}
/**
 * Log product interaction events for multiple cards being added to the compare bar; this fires
 * one event for _each_ card (so _N_ cards would trigger _N_ events).
 *
 * @param {Object[]} cards - list of card objects being added.
 * @param {string} [productLocation] - optional, product location.
 */


function logAddition(cards, productLocation) {
  cards.forEach(function (card) {
    logInteraction('ADD', card, productLocation);
  });
}
/**
 * Log product interaction events for a single card being removed from the compare bar.
 *
 * @param {Object} card - The card being removed.
 * @param {string} [productLocation] - optional, product location.
 */


function logRemoval(card, productLocation) {
  logInteraction('REMOVE', card, productLocation);
}
/**
 * @todo What drawer?
 * @param {Object} card -
 */


function logDrawerOpen(card) {
  logInteraction('DRAWER_OPEN', card);
}
/**
 * @todo What drawer?
 * @param {Object} card -
 */


function logDrawerClose(card) {
  logInteraction('DRAWER_CLOSE', card);
}
/**
 * Trigger a FICE indicating that the compare bar was cleared.
 */


function logClearComparedCards() {
  Tracking.formInputChanged({
    formName: 'compare_cards',
    inputType: 'BUTTON',
    fieldName: 'clear_compared_cards',
    fieldValue: ''
  });
}

export { logAddition, logRemoval, logDrawerOpen, logDrawerClose, logClearComparedCards };
export default {
  logAddition: logAddition,
  logRemoval: logRemoval,
  logDrawerOpen: logDrawerOpen,
  logDrawerClose: logDrawerClose,
  logClearComparedCards: logClearComparedCards
};
//# sourceMappingURL=log-interaction.js.map